import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { Step, StepResult, StepMap } from '@atlaskit/editor-prosemirror/transform';
export var overrideDocumentStepType = 'override-document';
export var OverrideDocumentStep = /*#__PURE__*/function (_Step) {
  _inherits(OverrideDocumentStep, _Step);
  var _super = _createSuper(OverrideDocumentStep);
  function OverrideDocumentStep(opts) {
    var _this;
    _classCallCheck(this, OverrideDocumentStep);
    _this = _super.call(this);
    _defineProperty(_assertThisInitialized(_this), "inverted", false);
    _defineProperty(_assertThisInitialized(_this), "oldDocumentSize", 0);
    var inverted = opts.inverted,
      nextDocument = opts.nextDocument;
    if (nextDocument.type.name !== 'doc') {
      throw new Error('nextDocument should be the entire prosemirror doc node and not only its content.');
    }
    _this.nextDocument = nextDocument;
    _this.inverted = Boolean(inverted);
    return _this;
  }
  _createClass(OverrideDocumentStep, [{
    key: "apply",
    value: function apply(doc) {
      this.oldDocumentSize = doc.content.size;
      return StepResult.ok(this.nextDocument);
    }
  }, {
    key: "map",
    value: function map() {
      return new OverrideDocumentStep({
        nextDocument: this.nextDocument,
        inverted: this.inverted
      });
    }
  }, {
    key: "getMap",
    value: function getMap() {
      if (!this.nextDocument || !this.oldDocumentSize) {
        return new StepMap([0, 0, 0]);
      }
      var oldSize = this.oldDocumentSize;
      var nextDocumentSize = this.nextDocument.content.size;
      return new StepMap([0, oldSize, nextDocumentSize]);
    }
  }, {
    key: "invert",
    value: function invert(doc) {
      return new OverrideDocumentStep({
        nextDocument: doc,
        inverted: true
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        stepType: overrideDocumentStepType,
        inverted: this.inverted,
        nextDocument: this.nextDocument.toJSON()
      };
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(schema, json) {
      if (!json || json.stepType !== overrideDocumentStepType) {
        throw new RangeError('Invalid overrideDocument step OverrideDocumentStep.fromJSON');
      }
      return new OverrideDocumentStep({
        inverted: json.inverted,
        nextDocument: schema.nodeFromJSON(json.nextDocument)
      });
    }
  }]);
  return OverrideDocumentStep;
}(Step);
Step.jsonID(overrideDocumentStepType, OverrideDocumentStep);